import { Component, Inject, OnInit, ViewChild} from '@angular/core';
import { apiService } from '../../../../service/api.service'
import { MatDialog } from '@angular/material/dialog';
import { ModalVideoComponent } from '../dialogs/modal-video/modal-video.component'
import { ModalMediosVerificacionComponent } from '../dialogs/modal-medios-verificacion/modal-medios-verificacion.component'
import { ModalResumenIntentosComponent } from '../dialogs/modal-resumen-intentos/modal-resumen-intentos.component'
import { MatStepper } from '@angular/material/stepper';
import { ModalResumenEvaluacionComponent } from '../dialogs/modal-resumen-evaluacion/modal-resumen-evaluacion.component'
import { ResponseEvaluacionModel, EvaluacionModel, ResponseResumenIntentosModel, ResponseResumenEvaluacionModel } from '../../../../model/Etapas.model'
import { StorageService } from 'src/app/service/storage.service';
import { CapacitacionJardinComponent } from '../capacitacion-jardin/capacitacion-jardin.component';

@Component({
  selector: 'app-etapas',
  templateUrl: './etapas.component.html',
  styleUrls: ['./etapas.component.css']
})
export class EtapasComponent implements OnInit {

  activeTabEtapa;
  etapaJardin = 0;
  test = false;
  opcionSiguiente = false;
  finalizarEvaluacion = false;
  cargando = true;
  cargandoCard = true;
  verCertificado = false;
  cantidadIntentos = 0;
  resumenIntentos = new ResponseResumenIntentosModel();
  evaluacion = new Array<EvaluacionModel>();

  @ViewChild('stepper') private myStepper: MatStepper;
  favoriteSeason: string;

  constructor(
    public dialog: MatDialog,
    private api: apiService,
    public storageService: StorageService,
    @Inject(CapacitacionJardinComponent) private parent: CapacitacionJardinComponent
    ) { }

  ngOnInit() { 
    this.activeTabEtapa = this.api.activeTabEtapa;
    this.api.activeTabEtapa = 0;
    this.etapaJardin = this.api.dataJardin.etapaJardin;
    this.comenzarEvaluacion();
  }

  siguiente(stepper: MatStepper) {
    stepper.next();
  }

  changeStep(event: any) {
    this.opcionSiguiente = false;
    if(event.selectedIndex == 9){
      this.finalizarEvaluacion = true;
    }
  }

  getResumen(){

    this.api.API_POST_obtenerResumenIntentos().subscribe((response: ResponseResumenIntentosModel) => {
      this.resumenIntentos = response;
      this.cantidadIntentos = this.resumenIntentos.payload.length;
      if(this.cantidadIntentos == 3){
        this.descargarCertificado();
      }else{
        this.cargandoCard = false
        this.verCertificado = false;
      }
    },
    (err) => {
      console.log(err)
    })     
  }

  verResumenIntentos(){
    const dialogRef = this.dialog.open(ModalResumenIntentosComponent ,{
      disableClose: true ,
      data: {dataResumen: this.resumenIntentos.payload},
      width: '50%',
    });
  }

  comenzarEvaluacion(){
    this.test=true;
    this.api.API_POST_obtenerEvaluacion().subscribe((response: ResponseEvaluacionModel) => {
      this.evaluacion = response.payload;
      this.cargando = false;
    },
    (err) => {
      console.log(err)
    })     
  }

  alternativaSeleccionada(alternativa,pregunta){  
    this.evaluacion[pregunta].alternativas.forEach((element)=>{
      element.seleccionada = false;
    });

    this.evaluacion[pregunta].alternativas[alternativa].seleccionada = true;
    this.opcionSiguiente = true;
  }

  enviarEvaluacion(){
    this.cargando = true;
    const json = {
      'idUsuario': this.storageService.getCurrentUser().idUsuario,
      'idJardin': this.api.dataJardin.id,
      'evaluacion': this.evaluacion

    }
     
    this.api.API_POST_enviarEvaluacion(json).subscribe((response: ResponseResumenEvaluacionModel) => {
      this.cargando = false;
      this.test=false;
      this.cargandoCard = true;
      this.getResumen();
     
      const dialogRef = this.dialog.open(ModalResumenEvaluacionComponent ,{
        disableClose: true ,
        data: response.payload,
        width: '65%',
      });

      this.parent.ngOnInit()
    },
    
    (err) => {
      console.log(err)
    })         
  }

  verMediosVerificacion(){
    const dialogRef = this.dialog.open(ModalMediosVerificacionComponent ,{
      disableClose: true ,
      width: '50%',
    });
  }

  descargarCertificado(){
    this.api.API_POST_obtenerCertificado().subscribe((response) => {
      this.cargandoCard = false;
      this.verCertificado = true;
      setTimeout(() => {
        document.getElementById('certificado').setAttribute('src','data:application/pdf;base64,'+response.payload.certificado);  
      }, 300);

    },
    (err) => {
      console.log(err)
    })  
  }

  irA(){
    this.api.emitDireccionamiento('autoevaluacion');
  }

}
